import { createContext, useContext } from "react";

const TestPreviewWidgetContext = createContext(null);

export function TestPreviewWidgetProvider({ children }) {
  const value = {};

  return <TestPreviewWidgetContext.Provider value={value}>{children}</TestPreviewWidgetContext.Provider>;
}

export function useTestPreviewWidgetContext() {
  const ctx = useContext(TestPreviewWidgetContext);
  if (!ctx) {
    throw new Error("useTestPreviewWidgetContext must be used within a TestPreviewWidgetProvider");
  }
  return ctx;
}
